import ReactToolTip from "react-tooltip";
// TODO: this component should not rely on outside stylesheets
import "../../../../auth/signup/register/Register.scss";
import "./ProfileRow.scss";

interface Props {
  label: string;
  value: string;
  onEdit: () => void;
  disabledTooltip?: string;
}

function ProfileRow({ label, value, onEdit, disabledTooltip }: Props) {
  return (
    <>
      <div className="row profile-row">
        <div className="column-1">{label}</div>
        <div className="column-2">{value}</div>
        <div className="column-3">
          <div
            onClick={disabledTooltip ? undefined : onEdit}
            className="hover"
            data-tip={disabledTooltip}
            style={disabledTooltip ? { color: "gray" } : undefined}
          >
            Edit
          </div>
        </div>
      </div>
      <ReactToolTip
        className="tooltip"
        multiline={true}
        effect="solid"
        textColor="#ffffff"
        backgroundColor="#2E2E2E"
        place="bottom"
      />
    </>
  );
}

export default ProfileRow;
